'use strict';

var styled = require('styled-components');
var cssUnits = require('../../helpers/css-units.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const Container = styled__default.default.i `
  position: relative;
  display: block;
  width: ${cssUnits.pxToEm('20px')};
  height: ${cssUnits.pxToEm('20px')};

  svg {
    animation: rotate 2s infinite linear;
    @keyframes dash {
      0% {
        stroke-dashoffset: 90;
        transform: rotate(0deg);
      }
      50% {
        stroke-dashoffset: 20;
        transform: rotate(45deg);
      }
      100% {
        stroke-dashoffset: 90;
        transform: rotate(360deg);
      }
    }

    @keyframes rotate {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }

  circle {
    stroke-dasharray: 100;
    animation: dash 1.3s infinite;
    stroke-linecap: square;
    transform-origin: center;
    stroke-dashoffset: 20;
    stroke: ;
  }
`;
const Styled = {
    Container,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
